import React from 'react'

var EventThankyou = React.createClass({
  propTypes: {
    message: React.PropTypes.string,
    continueUrl: React.PropTypes.string,
  },
  render: function() {
    const { message, continueUrl } = this.props;

    return(
      <div className="row">
        <div className="col-sm-offset-2 col-sm-8">
          <div className="panel">
            <div className="panel-heading">
              <div className="panel-title"> <span className="glyphicon glyphicon-ok"></span> Thank you </div>
            </div>

            <div className="panel-body">{message.split('\n').map(function(item, key) {
              return (
                <span key={key}>
                  {item}
                  <br/>
                </span>
              )
            })}</div>

            <div className="panel-footer text-right">
              <a href={continueUrl} className="btn btn-info btn-gradient">Continue</a>
            </div>
          </div>
        </div>
      </div>
    );
  }
});

export default EventThankyou;


// WEBPACK FOOTER //
// ./src/components/event_thankyou.js